import React from "react";
import { Link } from "react-router-dom";

import aboutImg from "../assets/images/features/about-2.png"

import {FiCheckCircle, MdKeyboardArrowRight} from '../assets/icons/vander'

export default function AboutTwo(){
    return(
        <>
            <div className="container relative md:mt-24 mt-16">
                <div className="grid md:grid-cols-2 grid-cols-1 items-center gap-6">
                    <div className="relative order-1 md:order-2">
                        <div className="relative overflow-hidden rounded-lg border border-amber-400/5 bg-gradient-to-tl pe-6 pt-6 lg:ms-8">
                            <img src={aboutImg} className="ltr:rounded-tr-lg rtl:rounded-tl-lg" alt=""/>
                        </div>
                    </div>

                    <div className="order-2 md:order-1">
                        <h4 className="mb-4 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold">Showcase Your AI Product to the World</h4>
                        <p className="text-slate-400">Join our marketplace and connect with users searching for innovative AI solutions like yours. Highlight your product’s features, gather reviews, and grow your user base effortlessly.</p>
                        <ul className="list-none text-slate-400 mt-4">
                            <li className="mb-2 flex items-center"><FiCheckCircle className="text-amber-400 h-5 w-5 me-2"/> List your AI product where businesses, and individuals come to find cutting-edge solutions</li>
                            <li className="mb-2 flex items-center"><FiCheckCircle className="text-amber-400 h-5 w-5 me-2"/> Provide detailed overviews and key features to attract potential users and build trust.</li>
                            <li className="mb-2 flex items-center"><FiCheckCircle className="text-amber-400 h-5 w-5 me-2"/> Interact with users, answer questions, and update your product info to stay ahead</li>
                            <li className="mb-2 flex items-center"><FiCheckCircle className="text-amber-400 h-5 w-5 me-2"/> Showcase real feedback from your users to boost credibility and drive more engagement</li>
                        </ul>

                    </div>
                </div>
            </div>
        </>
    )
}